import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import EditorAddIcon from '@atlaskit/icon/core/migration/add';
import { components } from '@atlaskit/select';

import { token } from '@atlaskit/tokens';

import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';
import type { RichIssueOptionType, PlainIssueOptionType } from './types.tsx';

const IssueCard = ({ imageUrl, children }: { imageUrl: string; children: ReactNode }) => (
	<IssueCardContainer>
		<IconContainer>
			<Img src={imageUrl} alt="" />
		</IconContainer>
		{children}
	</IssueCardContainer>
);

export const CreateIssueOption = ({ label }: { label: string }) => (
	<IssueCardContainer>
		<EditorAddIcon label="" LEGACY_size="small" color={token('color.icon.brand')} />
		<Button
			appearance="link"
			isSelected={false}
			interactionName="auto-generated.jira-issue-picker.ui.issue-cards.button"
		>
			{label}
		</Button>
	</IssueCardContainer>
);

export const IssueOption = ({ imageUrl, issueKey, summary }: RichIssueOptionType) => (
	<IssueCard imageUrl={imageUrl}>
		<IssueDescription>
			{issueKey} {summary}
		</IssueDescription>
	</IssueCard>
);

const SelectedValue = ({ imageUrl, issueKey, summary }: PlainIssueOptionType) => (
	<IssueCard imageUrl={imageUrl}>
		<IssueDescription>{`${issueKey} ${summary}`}</IssueDescription>
	</IssueCard>
);

export const SingleValue = ({
	children,
	...props
}: {
	children: ReactNode;
	data: PlainIssueOptionType;
}) => (
	// @ts-expect-error - TS2740 - Type '{ children: Element; data: PlainIssueOptionType; }' is missing the following properties from type 'CommonProps<PlainIssueOptionType, false, GroupTypeBase<PlainIssueOptionType>>': clearValue, cx, getStyles, getValue, and 8 more.
	<components.SingleValue {...props}>
		<SelectedValue
			imageUrl={props.data.imageUrl}
			issueKey={props.data.issueKey}
			summary={props.data.summary}
		/>
	</components.SingleValue>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueCardContainer = styled.div({
	display: 'flex',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IconContainer = styled.div({
	marginRight: token('space.100'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	width: `${2 * gridSize}px`,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	height: `${2 * gridSize}px`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Img = styled.img({
	height: '100%',
	width: '100%',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IssueDescription = styled.div({
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	flex: '1 1 100%',
	minWidth: 0,
});
